<template>
    <div class="ma-4">
      <v-sheet v-show="showSkeleton" class="pa-3">
        <v-skeleton-loader class="mx-auto" type="table" />
      </v-sheet>
  
      <div v-show="!showSkeleton" class="text-h4 mb-2">Integrações</div>
        <div>
          <v-row v-show="!showSkeleton">
            <v-col  cols="7" class="my-2">
              <AbaSigma/>
            </v-col>
            <v-col  cols="7" class="my-2">
              <AbaIa/>
            </v-col>
            
          </v-row>
        </div>
        

        
        
    </div>
  </template>
  
  <script>
  import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'
  import AbaSigma from '../_components/AbaSigma'
  import AbaIa from '../_components/AbaIa.vue'
  
  export default {
  
    mixins: [pagesHomeMixins],
    components: {AbaSigma, AbaIa},
  
    data: () => ({
      showSkeleton: true,
    }),
  
    computed: {
    },
  
    async created() {
      this.showSkeleton=false;
    },
  
    methods: {
    },
  }
  </script>
  